<template>
    <div class="chatList">
        <div class="scroll-box">
            <div v-infinite-scroll="getList" infinite-scroll-disabled="disabled">
                <div class="chat-item" v-for="(item,index) in userList" :key="index" :class="{active:curId == item.id}"
                    @click="selectUser(item)">
                    <div class="user-info">
                        <div class="hd">
                            <div class="name u-f u-ac u-jsb">
                                <div :title="item.type_text" class="itemnick">{{item.type_text}}</div>
                                <div :title="item.pay_amount" class="itemnick2">￥{{item.pay_amount}}</div>
                            </div>
                            <div class="name line1">
                                <div :title="item.pay_time" class="itemnick">{{item.pay_time}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p class="loadings" v-if="loading">{{to_user.show_user_id&&to_user.show_user_type=='user'?'加载中...':'请选择用户'}}
            </p>
            <p class="loadings" v-if="noMore">{{to_user.show_user_id&&to_user.show_user_type=='user'?'没有更多了':'请选择用户'}}</p>
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    import {
        HappyScroll
    } from 'vue-happy-scroll'
    export default {
        name: "chatList",
        props: ['to_user'],
        watch: {
            'to_user'(nVal, oVal) {
                this.loading = false
                this.userList = []
                this.page = 0
                // this.getList()
            }
        },
        data() {
            return {
                userList: [],
                loading: false,
                page: 0,
                curId: '',
                a: 1,
                // 总条数
                total: '',
                noMore: true,

            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            }),

            disabled() {
                return this.loading || this.userList.length >= this.total
            }

        },
        mounted() {
            // this.getList()

        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                if (!this.to_user.show_user_id || (this.to_user && this.to_user.show_user_type != 'user')) {
                    return false
                }
                this.loading = true
                this.page++;
                axios.post('/admin/pc/KtUserChatlist/userAllOrder', {
                    page: this.page,
                    user_id: this.to_user.show_user_id,
                }, {
                    token: true
                }).then(res => {
                    let userList = res.data.data.list
                    this.total = res.data.data.count
                    // this.userList = this.userList.concat(userList);
                    userList.forEach(item => {
                        this.userList.push(item)
                    })
                    this.loading = false;
                    if (this.userList.length>=this.total) {
                        this.noMore=true
                    }else{
                        // this.noMore=false
                    }

                }).catch((error) => {
                    console.log(error);
                    // this.loading = false;
                })
            },

            // 选择
            selectUser(item) {
                this.$nextTick(()=>{
                    this.$parent.selectorder(item)
                })
                this.bus.$emit('selectorder')
                // let vue = this
                // vue.$parent.page = 1
                // this.curId = item.id
                // vue.$emit('setDataId', item)
            },
        },
        destroyed() {
            // this.bus.$off()
        }
    }
</script>

<style lang="scss" scoped>
    .chatList {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 742px;
        border-right: 1px solid #ECECEC;

        .scroll-box {
            flex: 1;
            height: 500px;
            overflow: auto;

            .chat-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 12px 10px;
                border-bottom: 1px solid #f3f3f3;
                box-sizing: border-box;
                border-left: 3px solid transparent;
                cursor: pointer;

                &.active {
                    background: #EFF0F1;
                    border-left: 3px solid #1890FF;
                }
            }

            .loadings {
                text-align: center;
                padding: 10px 0;
                color: #999;
                font-size: 14px;
            }
        }
    }

    .user-info {
        width: 100%;
        margin-left: 12px;
        margin-top: 5px;
        font-size: 16px;

        .hd {

            color: rgba(0, 0, 0, 0.65);
            width: 100%;

            .name {
                width: 100%;
            }

            .itemnick {
                font-size: 14px;
                width: 75%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .itemnick2 {
                font-size: 14px;
                flex-grow: 1;
                color: red;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }


    .chart-scroll {
        margin-top: -10px;
    }
</style>